// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1oOH7","box":"WorkspacesBox_box__3R_EN","node":"WorkspacesBox_node__3d7Ap"};